import { Check } from "lucide-react";
import type { NavLayout } from "@shared/lib/types";
import { useNavLayout } from "../../lib/useNavLayout";
import { LayoutCardsIcon, LayoutSidebarIcon } from "./NavLayoutIcons";

const OPTIONS: {
  value: NavLayout;
  label: string;
  Icon: typeof LayoutCardsIcon;
}[] = [
  { value: "islands", label: "Dashboard cards", Icon: LayoutCardsIcon },
  { value: "sidebar", label: "Sidebar", Icon: LayoutSidebarIcon },
];

/**
 * Layout picker rendered inside the UserMenu dropdown. Lets the user switch
 * between the islands (dashboard cards) and sidebar navigation layouts.
 */
export function NavLayoutSelector() {
  const { layout, setLayout } = useNavLayout();

  return (
    <div className="px-2 py-1.5">
      <p className="px-2 pb-1 text-[11px] font-medium uppercase tracking-wide text-muted">
        Layout
      </p>
      <div role="radiogroup" aria-label="Navigation layout" className="space-y-0.5">
        {OPTIONS.map(({ value, label, Icon }) => {
          const active = layout === value;
          return (
            <button
              key={value}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => void setLayout(value)}
              className={`flex w-full items-center gap-2.5 rounded-md px-2 py-1.5 text-sm transition-colors ${
                active
                  ? "bg-surface2 text-foreground"
                  : "text-muted hover:bg-surface2 hover:text-foreground"
              }`}
            >
              <Icon size={18} className={active ? "text-accent" : ""} />
              <span className="flex-1 text-left">{label}</span>
              {active && <Check size={14} className="text-accent" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
